/**
 * Calendar Arche Page
 *
 * Route wrapper: ArcheLayout + Routes for the calendar arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { CalendarMainPage } from './CalendarMainPage';
import { AnalyticsPage } from './AnalyticsPage';

export function CalendarArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/*" element={<CalendarMainPage />} />
      </Routes>
    </ArcheLayout>
  );
}
